/* global Search */

if (document.querySelector(".fbjs-search--viewpoints")) {

    let hasActiveFilters;
    window.searchViewpoints = new Search.default({
        url: "https://dxp-uk-search.funnelback.squiz.cloud/s/search.json",
        collections: ["wood~sp-push-data"],
        additionalFBparams: {
            profile: "_default",
            "f.pageType|pageType": "insight - viewpoint",
        },
        onFiltersUpdate: () => {
            const activeFilters = window.searchReports?.search.activeFacets;
            for (const entry in activeFilters) {
                if (activeFilters[entry].length) {
                    hasActiveFilters = true;
                    return hasActiveFilters
                }
            }
        },
        beforeSearch: () => { },
        results: {
            numRanks: 9,
        },
        activeFacetsOnStart: {
            "f.pageType|pageType": [],
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
            "f.geographies|geographies": [],
        },
        sort: {
            type: "date",
        },
        pagination: {
            loadMore: true,
            arrows: false,
            arrowsOnEdgePages: false,
            dots: false,
            edgePages: false,
            pages: 0,
        },

        templates: {
            articleTemplate: (fields) => {
                // if (
                //     !addedResults.includes(fields.title.toLowerCase()) &&
                //     !addedIds.includes(fields.metaData.id)
                // ) {
                //     addedResults.push(fields.title.toLowerCase());
                //     addedIds.push(fields.metaData.id);
                const changeDate = () => {
                    const monthArray = [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ],
                        // dateFromFunnelback = fields.metaData.d, // 2017-08-10
                        splitedDate = fields.listMetadata.d[0].split("-");

                    return `${splitedDate[2]} ${monthArray[Number(splitedDate[1]) - 1]
                        } ${splitedDate[0]}`;
                };
                return `
                    <a href="${fields.liveUrl
                    }" class="cards__card-wrapper cards__card-wrapper--news date-mobile">
                        <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                            <div class="cards__image-wrapper">
                                <div class="cards__image"><img src="${fields.listMetadata.image ||
                    `https://woodplc.com/?a=235271`
                    }" alt=""></div>
                            </div>
                            <div class="cards__content no-gutters flex-column justify-content-between">
                              <div class="cards__title-wrapper">
                                <p class="cards__title truncate-lines-2">
                                ${fields.title}
                            </p>
                            </div>
                            <p class="cards__publish-date-mobile">${changeDate()}</p>
                            </div>
                        </article>
                    </a>`;
                // } else {
                //     return "";
                // }
            },
            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: () => {
                return "";
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                <div class="search-field">
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Viewpoints search"
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                </div>
                `;
            },
            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startrank
             * @returns {string}
             **/
            paginationNumberTemplate: () => {
                return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },
            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/
            activePaginationNumberTemplate: () => {
                return ""; //<li class="search__active-page hidden">${number}</li>
            },
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },

            /**
             * @name loadMoreTemplate
             * @param fields
             * @returns {string}
             **/
            loadMoreTemplate: () => {
                return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>';
            },

            facetCheckbox: ({ categories, singleChoice }, activeFacets, h) => {
                //{name, label}, activeFacets
                // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                categories[0].values.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${item.checked}
                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="${h.queryStringParamName}"
                                    data-singlechoice="${singleChoice}"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },

            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                // let spellSuggestion = "";
                // if (spell.text) {
                //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                // }
                return `<div>We're sorry, we couldn't find anything matching .</div>`;
            },
        },
    });

    window.searchViewpoints.init();
}
